<template>
  <vx-card id="activity-timeline" :title="`الجدول الزمني للنشاطات`" class="vs-con-loading__container" refresh-content-action @refresh="loadData">
    <VuePerfectScrollbar class="relative border border-solid rounded-lg d-theme-border-grey-light h-150" :class="{'mt-3': isTeacher}" :settings="settings">
      <div v-if="timelineData.length !== 0" class="px-4 pt-4">
        <vx-timeline :data="timelineData"></vx-timeline>
      </div>
      <div class="p-4 mt-16" v-else>
        <vs-icon class="mb-base block m-auto shadow-md rounded-full p-8 w-32 h-32 flex items-center justify-center"
                 size="3rem" icon-pack="feather" icon="icon-activity" />
        <h2 class="text-left text-primary mb-2">لا يوجد نشاطات</h2>
        <h5 class="text-left">
          <span>قم بالتحقق لاحقاً، سيتم عرض النشاطات الأخيرة الخاصة بالاختبارات والواجبات هنا.</span>
        </h5>
      </div>
    </VuePerfectScrollbar>
  </vx-card>
</template>

<script>
    import VuePerfectScrollbar from 'vue-perfect-scrollbar'
    import VxTimeline from '@/components/timeline/VxTimeline'
    import dashboardAPI from '@/api/admin/dashboardAPI'
    import moment from 'moment'

    export default {
        name: 'ActivityTimeline',
        components: { VxTimeline, VuePerfectScrollbar },
        data () {
            return {
                settings: {
                    maxScrollbarLength: 60,
                    wheelPropagation: true,
                },
                timelineData: [],
            }
        },
        watch: {
          '$route.params'(oldVal, val){
              if(oldVal.course_id !== val.course_id){
                  this.loadData()
              }
          }
        },
        methods: {
            parseData(data) {
                data.forEach(timeline => {
                    const jsonData = JSON.parse(timeline.data)

                    if(this.$route.params.course_id && this.$route.params.course_id !== jsonData.course) return

                    const date = new Date(timeline.date)
                    const course = this.$store.state.courses.all[jsonData.course].name
                    const timelineItem = {title: jsonData.title, time: timeline.date, color: 'primary'}

                    if(timeline.type === 'quiz'){
                        const time = moment(date).format('HH:mm')
                        timelineItem.desc = `إختبار يبدا الساعة ${time} (${course} - ${jsonData.group})`
                        timelineItem.icon = "HelpCircleIcon"
                    } else if(timeline.type === 'assignment') {
                        timelineItem.desc = `آخر موعد لتسليم الواجب (${course} - ${jsonData.group})`
                        timelineItem.icon = "FileTextIcon"
                    } else if(timeline.type === "event") {
                        timelineItem.icon = "CalendarIcon"
                    }

                    this.timelineData.push(timelineItem)
                })
                this.timelineData = this.timelineData.sort((a, b) => {
                    return moment(b.time).format('x') - moment(a.time).format('x')
                })
            },
            loadData(){
                this.timelineData = []
                this.$startLoading('#activity-timeline')
                dashboardAPI.activityTimeline()
                    .then(({data}) => {this.parseData(data.timeline)})
                    .finally(() => this.$closeLoading('#activity-timeline'))
            }
        },
        mounted() {
            this.loadData()
        }
    }
</script>
